export default "__VITE_ASSET__BaIaR_qM__"